import { render, staticRenderFns } from "./BestFeeds.vue?vue&type=template&id=39cbc1d4&"
import script from "./BestFeeds.vue?vue&type=script&lang=ts&"
export * from "./BestFeeds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports